/**
 * @generated SignedSource<<e84330fe60ca58a23461834274a51d29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontSocial_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontCallButton_viewer">;
  readonly " $fragmentType": "StorefrontSocial_viewer";
};
export type StorefrontSocial_viewer$key = {
  readonly " $data"?: StorefrontSocial_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontSocial_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontSocial_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontCallButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5d99f3cde3423e815e63e88579c0b4c1";

export default node;
